<template>
	<div>
		<div v-if="afficherTableauResultat">
			<v-card-title class="title-wrap">
				<h3>
					{{ titre }}
				</h3>

				<v-spacer />
			</v-card-title>

			<v-data-table
				v-model="selectedGardes"
				:headers="computedHeaders"
				:items="gardes"
				:custom-sort="customSort"
				:server-sort="false"
				item-key="id"
				:show-select="!rechercheGarde && utilisateurExterneInfo.peutValider"
				:loading="loading"
				:loading-text="loadingText"
				sort-by="gardeRecue.afficherDateDebut"
				:sort-desc="rechercheGarde"
				must-sort
				no-data-text="aucune donnée trouvée"
			>
				<template #progress>
					<v-progress-linear
						color="#00749c"
						:indeterminate="true"
						:value="100"
						height="1"
					/>
				</template>
				<template #item.gardeRecue.montant="{ item }">
					{{ item.gardeRecue.montant | formatMontant }}
				</template>
				<template #[`header.data-table-select`]="{ props, on }">
					<v-simple-checkbox
						:value="props.value || props.indeterminate"
						:indeterminate="props.indeterminate"
						v-on="on"
					/>
				</template>

				<template #item.actions="{ item }">
					<v-btn
						icon
						@click="afficherDetailGarde(item)"
					>
						<v-icon> {{ iconMDIEyeCircle }}</v-icon>
					</v-btn>
				</template>
			</v-data-table>

			<AmeliproDialog
				v-bind="$attrs"
				v-model="afficherModale"
				aria-labelledby="modal-title-exemple"
				labelledby="modaleConfirmationChangementStatutGarde"
				unique-id="genericModal"
				:fullscreen="isFullScreen"
				v-on="$listeners"
			>
				<template #header>
					<h2
						id="modal-title-exemple"
						class="ma-0 text-h4"
					>
						{{ modalTitre }}
					</h2>
				</template>

				<template #default>
					<div class="modal__content">
						<div
							v-if="isContenuTextuel"
							v-html="modalContenu"
						>
							{{ modalContenu }}
						</div>
						<!-- La clé force Vue à recréer le composant Detail -->
						<component
							:is="modalContenu"
							v-else
							:key="detailGarde?.id"
							:garde="detailGarde"
							@num-am-cible="handleSelectedValue"
						/>

						<div v-if="'validerDpa' == modalFooterAction">
							<ul>
								<li>
									Cette action vaut signature de la DPA et signifie que vous
									certifiez l’exactitude des informations des gardes
									sélectionnées.
								</li>
							</ul>
							<ul>
								<li>
									Une confirmation de votre demande est transmise à votre
									adresse e-mail.
								</li>
								<li>Le règlement sera effectué sous quelques jours.</li>
							</ul>
						</div>
					</div>
					<div
						v-if="afficherActionSupplementaire"
						class="modal__content"
					/>
				</template>

				<template #footer>
					<div class="d-flex flex-column flex-sm-row justify-sm-space-between">
						<AmeliproBtn
							class="mt-2 mt-sm-0"
							bordered
							@click="afficherModale = false"
						>
							Fermer
						</AmeliproBtn>
						<AmeliproBtn
							v-if="null != modalLibelleAction"
							@click="handleModalFooterAction"
						>
							{{ modalLibelleAction }}
						</AmeliproBtn>
					</div>
				</template>
			</AmeliproDialog>

			<div
				v-if="!rechercheGarde"
				class="mt-9 d-flex flex-wrap align-center justify-center justify-sm-start"
			>
				<AmeliproBtn
					class="mr-3 mb-3 mb-sm-0 v-btn-custom"
					width="250"
					:disabled="selectedGardes.length === 0"
					:badge="infosRecapitulatifGardes.nombreGardes"
					badge-bg-color="ap-white"
					badge-color="ap-blue"
					@click="confirmerValiderDpa"
				>
					Valider DPA
					<template #icon>
						{{ iconMDICheck }}
					</template>
				</AmeliproBtn>

				<AmeliproBtn
					class="mr-3 mb-3 mb-sm-0 v-btn-custom .v-btn-custom"
					:disabled="selectedGardes.length === 0"
					:badge="infosRecapitulatifGardes.nombreGardes"
					badge-bg-color="ap-white"
					badge-color="ap-blue"
					@click="confirmerInvaliderGarde"
				>
					Invalider garde
					<template #icon>
						{{ iconMDICancel }}
					</template>
				</AmeliproBtn>

				<AmeliproBtn
					v-if="
						utilisateurExterneInfo.isDocteur &&
							utilisateurExterneInfo.isExecutant
					"
					class="mr-3 mb-3 mb-sm-0 v-btn-custom"
					:disabled="selectedGardes.length === 0"
					:badge="infosRecapitulatifGardes.nombreGardes"
					badge-bg-color="ap-white"
					badge-color="ap-blue"
					@click="confirmerTransfertGarde"
				>
					Transfert autre N°AM
					<template #icon>
						{{ iconMDISwap }}
					</template>
				</AmeliproBtn>
			</div>
		</div>
		<!--<div v-if="filteredGardes.length === 0">
			Aucun donnée trouvée
		</div>-->
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import UserMixin from '@/mixins/userMixin';
	import PdfMixins from '@/mixins/pdfMixins';

	import { DataOptions } from 'vuetify';
	import { Garde } from '@/services/api/types';
	import { StateEnum } from '@cnamts/vue-dot/src/constants/enums/StateEnum';
	import { store } from '@/store';
	import { mdiCheck, mdiClose, mdiSwapHorizontal, mdiEyeCircle } from '@mdi/js';
	import { updateEtatApi, transfertEtatApi } from '@/services/api/api';
	import { ACTIONS } from '@/services/constantes';
	import { ItemSelect } from '@/services/api/types';
	import Transfert from '@/components/dpa/Transfert.vue';
	import Detail from '@/views/Garde/Detail.vue';
	import { HistoriqueDpa } from '@/services/api/types';
	import { formatDate } from '@/services/dateFormatter';
	import { TYPE_STATUT } from '@/services/constantes';
	const MixinsDeclaration = mixins(UserMixin, PdfMixins);
	const TransfertInstance = Vue.extend(Transfert);

	@Component<ListeGardeByUser>({
		components: {
			Detail
		},
		created() {
			// Chargement des gardes par défaut, afin d'alimenter les filtres
			this.fetchData();
		},
		props: {
			filteredGardesLocal: Array as () => Garde[],
			rechercheGarde: {
				type: Boolean,
				default: false
			},
			afficherTableauResultat: {
				type: Boolean,
				default: false
			},
			titre: {
				type: String,
				default: ''
			},
			statutFiltre: {
				type: String,
				default: ''
			},
			afficherDetail: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			filteredGardesLocal: {
				handler(localFilteredGardes) {
					// Met à jour les gardes en fonction des filtres
					this.gardes = localFilteredGardes;
					this.selectedGardes = [];
				},
				deep: true // "deep" pour observer les changements internes
			},
			afficherTableauResultat: {
				handler() {
					this.selectedGardes = [];
				},
				immediate: true,
				deep: true // "deep" pour observer les changements internes
			},
			selectedGardes: function () {
				this.calculerRecapitulatifGardes();
				this.getAmAttaches();
			}
		},
		methods: {
			handleLogoutClick() {
				if (this.$route.path != '/logout') {
					this.$router.push('/logout');
				}
			}
		},
		computed: {
			// Calcule si le contenu de la modal est une chaîne de texte ou un composant
			isContenuTextuel() {
				return typeof this.modalContenu === 'string';
			},

			// Filtre le header (détails ect)
			computedHeaders() {
				this.headers.push(
					{
						value: 'gardeRecue.numero',
						text: 'Numéro',
						align: 'start',
						width: '10%'
					},
					{
						value: this.utilisateurExterneInfo.isDelegataire
							? 'executant.informationExecutantPourDelegataire'
							: 'numeroPaiement',
						text: 'Exécutant',
						align: 'start',
						width: '10%'
					},
					{
						value: 'gardeRecue.afficherDateDebut',
						text: 'Début',
						align: 'start',
						width: '10%'
					},
					{
						value: 'gardeRecue.afficherDateFin',
						text: 'Fin',
						align: 'start',
						width: '10%'
					},
					{
						value: 'gardeRecue.codeActe',
						text: 'Code acte',
						align: 'start',
						width: '10%'
					},
					{
						value: 'gardeRecue.montant',
						text: 'Montant',
						align: 'start',
						width: '10%'
					},
					{
						value: 'gardeRecue.secteur',
						text: 'Secteur',
						align: 'start',
						width: '10%'
					},
					{
						value: 'gardeRecue.lot.departement.libelleComplet',
						text: 'Département',
						align: 'start',
						width: '10%'
					},
					{
						value: 'statutLibelleFront',
						text: 'Statut',
						align: 'start',
						width: '10%'
					},
					{
						value: 'lotPrint',
						text: 'Lot',
						align: 'start',
						width: '10%'
					}
				);

				if (this.$props.afficherDetail) {
					this.headers.push({
						value: 'actions',
						text: 'Détail',
						align: 'center',
						sortable: false
					});
				}
				return this.headers;
			}
		}
	})
	export default class ListeGardeByUser extends MixinsDeclaration {
		selectedGardes: Garde[] = [];
		detailGarde: Garde | null = null;
		localFilteredGardes: Garde[] = [];
		//afficherTableauResultat = false;
		infosRecapitulatifGardes: {
			nombreGardes: number;
			total: number;
		} = {
			nombreGardes: 0,
			total: 0
		};

		headerProps = {
			align: 'center',
			color: '#00749c',
			dense: true,
			height: '500px'
		};

		headers: {
			value: string;
			text: string;
			align: string;
			width?: string;
			sortable?: boolean;
		}[] = [];

		search = '';
		iconMDICancel = mdiClose;
		iconMDICheck = mdiCheck;
		iconMDISwap = mdiSwapHorizontal;
		iconMDIEyeCircle = mdiEyeCircle;

		StateEnum = StateEnum;

		state = StateEnum.IDLE;

		dataOptions = {} as DataOptions;

		afficherModale = false;
		isFullScreen = false;
		afficherActionSupplementaire = false;
		modalTitre = '';
		modalContenu = '';
		modalFooterAction = '';
		modalLibelleAction: string | null = '';
		loading = false;
		numAmCibles: ItemSelect[] = [];
		loadingText = 'Chargement des gardes en cours...';
		messageConfirmationGarde = '';
		numAmCible = '';
		texteInvalider = '';
		texteValider = '';

		async fetchData(): Promise<void> {
			try {
				this.loading = true;

				// Récupération des gardes ou Dpa
				const actionType =
					this.$props.statutFiltre === TYPE_STATUT.A_VALIDER
						? 'fetchGardesAValider'
						: 'fetchGardes';
				await this.$store.dispatch(`garde/${actionType}`);

				// Récupération depuis le store
				const fetchedGardes = this.$store.getters['garde/getGardes'];

				if (fetchedGardes) {
					this.gardes = fetchedGardes;
					// Mise à jour des champs de recherche
					this.$emit('resultats-disponibles');
				}
			} catch (error) {
				store.dispatch('notification/add', {
					type: 'error',
					message: 'Une erreur est survenue lors de la récupération des gardes'
				});
			} finally {
				this.selectedGardes = [];
				this.loading = false;
			}
		}

		calculerRecapitulatifGardes(): void {
			let nombreGardes = 0;
			let total = 0;
			if (this.selectedGardes.length > 0) {
				// Parcourt chaque garde sélectionnée pour calculer le total des montants
				this.selectedGardes.forEach((gardeSelected) => {
					total += parseFloat(gardeSelected.gardeRecue.montant);
				});
				nombreGardes = this.selectedGardes.length;
				total = parseFloat(total.toFixed(2));
			}
			// Retourne les résultats calculés
			this.infosRecapitulatifGardes = {
				nombreGardes,
				total
			};

			this.creerMessageConfirmation();

			this.$root.$emit(
				'infos-recapitulatif-gardes',
				this.infosRecapitulatifGardes
			);
		}

		creerMessageConfirmation(): void {
			const nombreGardes = this.infosRecapitulatifGardes.nombreGardes;
			const montantTotal = this.infosRecapitulatifGardes.total;

			this.texteInvalider = `Vous allez demander l'invalidation de <strong>${nombreGardes} garde${
				nombreGardes > 1 ? 's' : ''
			}</strong> représentant un montant total de <strong>${montantTotal} €</strong>. Ces gardes ne pourront plus faire l'objet d'une demande de paiement`;

			this.texteValider = `Vous allez demander le paiement de <strong>${nombreGardes} garde${
				nombreGardes > 1 ? 's' : ''
			}</strong> pour un montant total de <strong>${montantTotal} €</strong>`;
		}

		async updateEtatGarde(etat: number): Promise<void> {
			const response = await updateEtatApi(this.selectedGardes, etat);
			if (response && response.status === 200) {
				// Met à jour les gardes
				this.fetchData();
			}
		}

		async transfertGarde(): Promise<void> {
			try {
				const response = await transfertEtatApi(
					this.selectedGardes,
					this.numAmCible
				);
				if (response && response.status === 200) {
					// Met à jour les gardes
					this.fetchData();
					const messageValidation = this.buildMessage(
						this.selectedGardes,
						'Transfert '
					);

					store.dispatch('notification/add', {
						type: 'success',
						message: messageValidation
					});
				}
			} catch (error) {
				store.dispatch('notification/add', {
					type: 'error',
					message: this.buildMessage(
						this.selectedGardes,
						'Une erreur est survenue lors du transfert '
					)
				});
			} finally {
				this.afficherModale = false;
				this.fetchData();
			}
		}

		private buildMessage(selectedGardes: Garde[], message: string) {
			if (selectedGardes.length === 0) {
				message += 'Aucune garde sélectionnée.';
			} else if (selectedGardes.length === 1) {
				message += `de la garde numéro: ${selectedGardes[0].gardeRecue.numero}`;
			} else {
				message +=
					'des gardes numéro: ' +
					selectedGardes.map((garde) => garde.gardeRecue.numero).join(', ');
			}

			message += this.messageConfirmationGarde;

			return message;
		}

		private buildMessageErreur(
			data: { erreurs: { [key: string]: string[] } } | null
		): string {
			let message = '. ';

			if (!data || !data.erreurs || Object.keys(data.erreurs).length === 0) {
				return '';
			} else {
				// Récupère par défaut la première valeur du tableau associé à la première clé (correspond à celui de la garde)
				const firstError = data.erreurs[Object.keys(data.erreurs)[0]][0];
				message += firstError;
			}

			return message;
		}

		private validerDpa() {
			this.afficherModale = false;
			this.updateEtatGarde(ACTIONS.VALIDER_DPA)
				.then(() => {
					//let messageValidation = this.buildMessage(this.selectedGardes, 'Validation ');
					const messageValidation = `
    Votre Demande de Paiement d’Astreintes Electronique a été prise en compte.
    Une confirmation vous a été transmise par courrier électronique à l’adresse ${this.utilisateurExterneInfo.email}.
    Le règlement correspondant sera effectif d’ici quelques jours.
`;

					store.dispatch('notification/add', {
						type: 'success',
						message: messageValidation
					});

					// Affichage récapitulatif des gardes validées
					this.viewPreuve();
				})
				.catch((error: any) => {
					store.dispatch('notification/add', {
						type: 'error',
						message:
							this.buildMessage(
								this.selectedGardes,
								'Une erreur est survenue lors de la validation '
							) + this.buildMessageErreur(error.response.data)
					});
				})
				.finally(() => {
					this.fetchData();
				});
		}

		private invaliderGarde() {
			this.updateEtatGarde(ACTIONS.INVALIDER_DPA)
				.then(() => {
					store.dispatch('notification/add', {
						type: 'success',
						message: this.buildMessage(this.selectedGardes, 'Invalidation ')
					});
				})
				.catch((error: any) => {
					store.dispatch('notification/add', {
						type: 'error',
						message:
							this.buildMessage(
								this.selectedGardes,
								'Une erreur est survenue lors de l\'invalidation '
							) + this.buildMessageErreur(error.response.data)
					});
				})
				.finally(() => {
					this.afficherModale = false;
					this.fetchData();
				});
		}

		private afficherModal(
			titre: string,
			contenu: any,
			action: string,
			libelleAction: string | null,
			afficherActionSupplementaire: boolean,
			isFullScreen: boolean
		) {
			this.modalTitre = titre;
			this.modalContenu = contenu;
			this.modalFooterAction = action;
			this.modalLibelleAction = libelleAction;
			this.afficherModale = true;
			this.afficherActionSupplementaire = afficherActionSupplementaire;
			this.isFullScreen = isFullScreen;
		}

		private transmettreNumeroAMConcernes(): void {
			const numAmConcernes = this.getNumAmConcernes();
			this.$root.$emit('numeroam-concernes', numAmConcernes);
		}

		confirmerValiderDpa(): void {
			this.afficherModal(
				'Demande de paiement',
				this.texteValider,
				'validerDpa',
				'Confirmer DPA',
				true,
				false
			);
		}

		confirmerInvaliderGarde(): void {
			this.afficherModal(
				'Invalidation de gardes',
				this.texteInvalider,
				'InvaliderGarde',
				'Confirmer l\'invalidation',
				false,
				false
			);
		}

		getNumAmConcernes(): string[] {
			const numAmConcernes: string[] = [];
			if (this.selectedGardes.length > 0) {
				this.selectedGardes.forEach((gardeSelected) => {
					numAmConcernes.push(gardeSelected.numeroPaiement);
				});
			}
			return numAmConcernes;
		}

		getAmAttaches(): void {
			this.transmettreNumeroAMConcernes();
		}

		confirmerTransfertGarde(): void {
			this.afficherModal(
				'Transfert de gardes',
				TransfertInstance,
				'transfertGarde',
				'Confirmer le transfert',
				false,
				false
			);
			// Attend mise à jour complète du DOM
			this.$nextTick(() => {
				this.transmettreNumeroAMConcernes();
			});
		}

		afficherDetailGarde(garde: Garde): void {
			this.detailGarde = garde;
			this.afficherModal('Fiche garde', Detail, 'detailGarde', null, false, true);
		}

		handleModalFooterAction(): void {
			if (this.modalFooterAction === 'validerDpa') {
				this.validerDpa();
			} else if (this.modalFooterAction === 'InvaliderGarde') {
				this.invaliderGarde();
			} else if (this.modalFooterAction === 'transfertGarde') {
				this.transfertGarde();
			}
		}

		handleSelectedValue(value?: string): void {
			if (value) {
				this.numAmCible = value;
			}
		}

		//TODO A factoriser. Erreur "options is undefined" dans mixins
		viewPreuve(dpa: HistoriqueDpa | null = null): void {
			let dateJour = '';
			if (dpa && dpa.jour) {
				dateJour = dpa.jour;
			} else {
				const currentDate = new Date();
				dateJour = currentDate.toISOString().slice(0, 10);
			}
			this.getPdfDpa(formatDate(dateJour));
		}

		private customSort(
			items: any[],
			sortBy: string[],
			sortDesc: boolean[]
		): any[] {
			if (!sortBy.length) return items;

			const column = sortBy[0];

			// Tri personnalisé pour les dates
			if (
				column === 'gardeRecue.afficherDateDebut' ||
				column === 'gardeRecue.afficherDateFin'
			) {
				return [...items].sort((a, b) => {
					const dateA = this.convertToDate(
						column === 'gardeRecue.afficherDateFin'
							? a.gardeRecue.afficherDateFin
							: a.gardeRecue.afficherDateDebut
					);
					const dateB = this.convertToDate(
						column === 'gardeRecue.afficherDateFin'
							? b.gardeRecue.afficherDateFin
							: b.gardeRecue.afficherDateDebut
					);

					return sortDesc[0]
						? dateB.getTime() - dateA.getTime()
						: dateA.getTime() - dateB.getTime();
				});
			}

			// Tri standard pour les autres colonnes
			return [...items].sort((a, b) => {
				const valA = this.getNestedValue(a, column);
				const valB = this.getNestedValue(b, column);

				return sortDesc[0] ? (valB > valA ? 1 : -1) : valA > valB ? 1 : -1;
			});
		}

		// accès aux propriétés imbriquées
		private getNestedValue(obj: any, path: string): any {
			const value = path.split('.').reduce((current, key) => current[key], obj);

			// Tri sur la partie numérique du numéro
			if (path === 'executant.informationExecutantPourDelegataire') {
				return Number(value.split(' - ')[0]);
			}

			if (path === 'gardeRecue.numero' || path === 'numeroPaiement') {
				return Number(value);
			}

			return value;
		}

		private convertToDate(dateStr: string): Date {
			const [date, time] = dateStr.split(' ');
			const [day, month, year] = date.split('/');
			const [hours, minutes] = time.split(':');
			return new Date(+year, +month - 1, +day, +hours, +minutes);
		}
	}
</script>
<style lang="scss" scoped>
.modal__content {
  padding: 30px 16px;
}
</style>
